<template>
  <fragment>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseSelect
          required
          tabindex="2"
          :label="$t('events.category')"
          item-text="descricao"
          item-value="idcategoria"
          :placeholder="$t('events.select-category')"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.categorias_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.categoria"
        />
      </v-col>
      <v-col>
        <BaseMoneyField
          required
          tabindex="3"
          :label="$t('events.event-config.price')"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseSelect
          required
          tabindex="1"
          label="Status"
          item-text="value"
          item-value="key"
          :placeholder="$t('events.select-status')"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.status_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.status"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseTextField
          :required="requiredUrl"
          :label="$t('events.event-config.link-url')"
          :placeholder="$t('events.event-config.insert-link-url')"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.url_link"
        />
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <BaseTextField
          :label="$t('events.event-config.event-date-hour')"
          type="datetime"
          v-mask="'##/##/#### ##:##'"
          placeholder="dd/mm/aaaa hh:mm"
          append-icon="mdi-calendar"
          persistent-hint
          :rules="dateRequired"
          :hint="apresentationDateExplain"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao
          "
        />
      </v-col>
    </v-row>
    <label style="font-weight: 600; font-size: 14px">{{
      $t("events.event-config.event-address")
    }}</label>
    <v-divider class="mb-5"></v-divider>
    <v-row>
      <v-col cols="12" sm="6">
        <BaseTextField
          :label="$t('events.event-config.event-location')"
          :placeholder="$t('events.event-config.insert-event-location')"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.endereco"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :label="$t('events.event-config.country')"
          item-text="dsc_lang"
          needSelection
          item-value="iso_full"
          :placeholder="$t('events.event-config.select-country')"
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_paises"
          :items="$config.paises.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.pais"
        >
          <template v-slot:selection="{ item }">
            <v-chip small v-bind="item" :input-value="item">
              <template v-if="item ? (paises = item) : null">
                {{ item.dsc_lang }}
              </template>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :label="$t('events.event-config.state')"
          item-text="dsc_lang"
          item-value="iso_full"
          needSelection
          :placeholder="$t('events.event-config.select-state')"
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_estados"
          :items="$config.estados.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.estado"
        >
          <template v-slot:selection="{ item }">
            <v-chip small v-bind="item" :input-value="item.selected">
              <template v-if="item ? (estados = item) : null">
                {{ item.dsc_lang }}
              </template>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <BaseAutocomplete
          :label="$t('events.event-config.city')"
          item-text="dsc_lang"
          item-value="dsc_lang"
          :placeholder="$t('events.event-config.select-city')"
          :loading="$config.loading_cidades"
          :items="$config.cidades.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.cidade"
        >
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <label style="font-weight: 600; font-size: 14px">
      {{ $t("events.event-config.complementary-info") }}
    </label>
    <v-divider class="mb-5"></v-divider>
    <v-row>
      <v-col cols="12" sm="6">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          :label="$t('events.event-config.highlight-product')"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          hide-details
        >
        </v-checkbox>
      </v-col>
    </v-row>
  </fragment>
</template>
<script>
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
const { products, formRules } = mixins;
export default {
  name: "LinkProduct",
  mixins: [products, formRules],
  components: {
    BaseSelect,
    BaseMoneyField,
    BaseTextField,
    BaseAutocomplete,
  },
  data: () => ({
    paises: [],
    estados: [],
    cidades: [],
    descricao: "",
    descritivo: "",
  }),
  computed: {
    apresentationDateExplain() {
      return `ℹ️ ${this.$t("events.event-config.event-date-hour-info")}`;
    },
    dateRequired() {
      const courtesyAndTicket =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "INGRESSO" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA";
      const someProductWithOptionDate =
        this.$produtos_gerenciar.cadastro.variacoes.opcoes.some(item => {
          return item.tipo === "DATA";
        });

      return courtesyAndTicket && !someProductWithOptionDate
        ? [this.rules.required]
        : [];
    },
    requiredUrl() {
      return !this.$produtos_gerenciar.cadastro.dados_cadastrais
        .prod_agrupamento;
    },
  },
  watch: {
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estados(e) {
      this.$config.getCidades(e.id);
    },
  },
  mounted() {
    this.$config.getPaises();
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.pais) {
      this.pais = this.$produtos_gerenciar.cadastro.dados_cadastrais.pais;
    }

    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.estado) {
      this.estado = this.$produtos_gerenciar.cadastro.dados_cadastrais.estado;
    }
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.cidade) {
      this.cidade = this.$produtos_gerenciar.cadastro.dados_cadastrais.cidade;
    }
  },
};
</script>
<style></style>
